<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section']" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container has-text-centered">
        <h2 class="title">{{block.title}}</h2>
        <div class="content" ref="content" v-html="block.content"></div>
        <agile v-if="block.carousel && block.carousel.items.length > 0" :options="block.carousel.config">
            <template v-for="item, i in block.carousel.items">
                <div v-if="block.largeImage > 0 && item.large_image" :class="['column', 'large_image']">
                    <img :alt="item.large_image.title" v-if="!item.link" :src="item.large_image.url" />
                    <template v-else>
                        <router-link :target="item.link.open_in_blank ? '_blank' : null" v-if="item.link.is_internal" :to="item.link.url"><img :alt="item.large-image.title" :src="item.large-image.url" /></router-link>
                        <a :target="item.link.open_in_blank ? '_blank' : null" v-else :href="item.link.url"><img :alt="item.large-image.title" :src="item.large-image.url" /></a>
                    </template>
                </div>
                <div :class="['column']" v-else-if="item.image">
                    <img :alt="item.image.title" v-if="!item.link" :src="item.image.url" />
                    <template v-else>
                        <router-link :target="item.link.open_in_blank ? '_blank' : null" v-if="item.link.is_internal" :to="item.link.url"><img :alt="item.image.title" :src="item.image.url" /></router-link>
                        <a :target="item.link.open_in_blank ? '_blank' : null" v-else :href="item.link.url"><img :alt="item.image.title" :src="item.image.url" /></a>
                    </template>
                </div>
            </template>
        </agile>
        <div class="cta" v-if="block.cta && block.cta.button">
            <CTALink :link_data="block.cta" />
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import { VueAgile } from 'vue-agile';
export default {
    name        :   'ContentCarouselActionBlock',
    mixins      :   [ BlockCommons ],
    components  :   {
        agile   :   VueAgile
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/ContentCarouselActionBlock.vue